import { SalesPackage, Offer } from '../types';
interface IProductInfo {
  [key: number]: { name: string; extraName?: string };
}

export const isDefined = <T>(t: T | undefined | null): t is T => t !== undefined && t !== null;

export const isUndefined = <T>(t: T | undefined | null): t is null | undefined => !isDefined(t);

export type Comparator<T> = (one: T, two: T) => -1 | 0 | 1;

export const backendUrls = {
  supportApi: 'http://localhost:8000',
  addressSearchPath: '/address/search'
};

const searchParams = new URLSearchParams(window.location.href.split('priser?')[1]);
export const vaidAsQParam = searchParams.get('vaid') || '';
export const backUrlAsParam = searchParams.get('backUrl');
export const fallbackUrlAsParam = searchParams.get('fallbackUrl');

export const routes: { [key: string]: string } = {
  address: backUrlAsParam ? window.location.origin + backUrlAsParam : '/',
  prices: '/priser',
  additionalProducts: '/tilleggsprodukter',
  personalia: '/personalia',
  receipt: '/kvittering'
};

export const capitalizeFirstLetter = ([first, ...rest]: string) => {
  return [first.toUpperCase(), ...rest].join('');
};

const mobileSize = 500;

export const isMobile = () => window.innerWidth < mobileSize;

const reverseObjectKeyValue = (originalObject: { [key: string]: string }) =>
  Object.keys(originalObject).reduce((reveresed: { [key: string]: string }, key: string) => {
    reveresed[originalObject[key]] = key;
    return reveresed;
  }, {});

// 7: 4G bredbånd 25 - Kostnadsfri installasjon
// 8: 4G bredbånd 50 - Kostnadsfri installasjon
// 9: 4G bredbånd 75 - Kostnadsfri installasjon
// 10: 4G bredbånd 25 - Kostnadsfri installasjon
// 11: 4G Bredbånd 50 - Kostnadsfri installasjon
// 12: 4G Bredbånd 75 - Kostnadsfri installasjon
// 13: 5G bredbånd 100 - Kostnadsfri installasjon
// 14: 5G bredbånd 250 - Kostnadsfri installasjon
// 15: 5G bredbånd 500 - Kostnadsfri installasjon
// 16: 5G bredbånd 100 - Kostnadsfri installasjon
// 17: 5G bredbånd 250 - Kostnadsfri installasjon
// 18: 5G bredbånd 500 - Kostnadsfri installasjon
// 19: 5G-Ready Bredbånd 25
// 20: 5G-Ready Bredbånd 50
// 21: 5G-Ready Bredbånd 75
// 22: 4G bredbånd Hytte 50 - Kostnadsfri installasjon
// 23: 4G bredbånd Hytte 75 - Kostnadsfri installasjon

// Hytte 23100852
// 4g dupe 23627354
// 5g-ready 22243586
// 4og5g 22870285

const packageTypeId = {
  '4g': [7, 8, 9, 10, 11, 12, 22, 23],
  '5g': [13, 14, 15, 16, 17, 18],
  '5g-tv': [24, 25, 26],
  '5g-ready': [19, 20, 21],
  '5g-ready-tv': [27, 28, 29],
  '5g-ready-cabin': [30, 31],
  '5g-cabin': [32, 33]
};

//'16': '24',
//'17': '25',
// '18': '26',
export const idWithTV: { [key: string]: string } = {
  '13': '24',
  '14': '25',
  '15': '26',
  '19': '27',
  '20': '28',
  '21': '29'
};
// 16 is 13 with offer
// export const idWithTV = (id:number) => {
//   if(id === 13 || id === 16) {

//   }
//   '13': '24',
//   '14': '25',
//   '15': '26',
//   '19': '27',
//   '20': '28',
//   '21': '29'
// };

export const idWithoutTV: { [key: string]: string } = reverseObjectKeyValue(idWithTV);
export const getSalesPackageById = (salesPakages: SalesPackage[], id: number) => {
  return salesPakages.filter(pck => pck.id === id)[0];
};
export const cabinEstablishmentId = 1229;
const installmentOfferFiveG = 1212;
const freeInstallmentFourG = 1153;
const freeInstallmentCabin = 1230;
const fiveGreadyCabinCampaign = 1213;
export const AppleTvCPID = 2015;
export const OpptakCPID = 1605;
export const isCabin = (pck: SalesPackage) => pck.id === 22 || pck.id === 23;

type PackageGroups = {
  hasCabinEstablishmentOffer: boolean;
  isCabinProduct: boolean;
  has4GOffer: boolean;
  hasInstallamentOfferFiveG: boolean;
  hasFreeInstallamentFourG: boolean;
  hasFreeInstallamentCabin: boolean;
  hasFiveGCabinInstamentOffer: boolean;
  fourGPackages: SalesPackage[];
  fiveGPackages: SalesPackage[];
  fiveGReadyPackages: SalesPackage[];
  fiveGWithTvPackages: SalesPackage[];
  fiveGReadyWithTVPackages: SalesPackage[];
  fiveGReadyCabin: SalesPackage[];
  fiveGCabin: SalesPackage[];
};

// Package ID	Offer	BB Speed
// 5g
// 13      	1293	100
// 14      	1282	250
// 15       1283	500

// 5g-ready
// 19      	1291	25
// 20      	1292	50
// 24      	1293	100

// 5g-tv
// 25      	1282	250
// 26      	1283	500

//5g-ready-tv
// 27      	1291	25
// 28      	1292	50

export const productInfoLookUp: IProductInfo = {
  7: { name: 'Bredbånd 25' },
  8: { name: 'Bredbånd 50' },
  9: { name: 'Bredbånd 75' },
  10: { name: 'Bredbånd 25' },
  11: { name: 'Bredbånd 50' },
  12: { name: 'Bredbånd 75 ' },
  13: { name: 'Bredbånd 100' },
  14: { name: 'Bredbånd 250' },
  15: { name: 'Bredbånd 500' },
  16: { name: 'Bredbånd 100' },
  17: { name: 'Bredbånd 250 ' },
  18: { name: 'Bredbånd 500' },
  19: { name: 'Bredbånd 25' },
  20: { name: 'Bredbånd 50' },
  21: { name: 'Bredbånd 75' },
  22: { name: 'Bredbånd 25', extraName: 'Hytte' },
  23: { name: 'Bredbånd 50', extraName: 'Hytte' },
  24: { name: 'TV & Strømming' }, //5g with Tv
  25: { name: 'TV & Strømming' }, // 5g with Tv
  26: { name: 'TV & Strømming' }, // 5g with Tv
  27: { name: 'TV & Strømming' }, // 5g ready with Tv
  28: { name: 'TV & Strømming' }, // 5g ready with Tv
  29: { name: 'TV & Strømming' }, // 5g ready with Tv
  30: { name: 'Bredbånd 25', extraName: 'Hytte' }, // 5g ready cabin
  31: { name: 'Bredbånd 50', extraName: 'Hytte' }, // 5g ready cabin
  32: { name: 'Bredbånd 100', extraName: 'Hytte' }, // 5g cabin
  33: { name: 'Bredbånd 250', extraName: 'Hytte' } // 5g cabin
};

export const offerInfoLookup: { [key: number]: string } = {
  1154: 'Kostnadsfri 1 md.',
  1155: 'Kostnadsfri 2 md.',
  1156: 'Kostnadsfri 3 md.',
  1207: 'Kostnadsfri 1 md.',
  1208: 'Kostnadsfri 2 md.',
  1229: '', // Cabin installasjonskampanje
  1213: '', // 5g-ready installasjonskampanje
  1153: 'Fri installasjon', // Kostnadsfri installasjon 4G
  1206: 'Fri installasjon', // Kostnadsfri installasjon 5g
  1230: 'Fri installasjon', // Kostnadsfri installasjon Cabin
  1212: 'Installasjon kr 1999', // 5g installasjonskampanje
  1293: '', // 150 kr i 6 md.
  1282: '', // 150 kr i 6 md.
  1283: '', // 150 kr i 6 md.
  1290: '', // 150 kr i 6 md.
  1291: '', // 150 kr i 6 md.
  1292: '' // 150 kr i 6 md.
};

const hasOfferOfId = (offers: Offer[], offerid: number) => offers.filter(offer => offer.id === offerid).length > 0;

export const ribbonTextLookup: { [key: number]: string } = {
  [cabinEstablishmentId]: 'Nyhet'
};

export const getPackageGroups = (packages: SalesPackage[]): PackageGroups => {
  const fourGPackages: SalesPackage[] = [];
  const fiveGPackages: SalesPackage[] = [];
  const fiveGWithTvPackages: SalesPackage[] = [];
  const fiveGReadyPackages: SalesPackage[] = [];
  const fiveGReadyWithTVPackages: SalesPackage[] = [];
  const fiveGReadyCabin: SalesPackage[] = [];
  const fiveGCabin: SalesPackage[] = [];

  packages.forEach(pck => {
    if (packageTypeId['4g'].includes(pck.id)) {
      fourGPackages.push(pck);
    } else if (packageTypeId['5g'].includes(pck.id)) {
      fiveGPackages.push(pck);
    } else if (packageTypeId['5g-ready'].includes(pck.id)) {
      fiveGReadyPackages.push(pck);
    } else if (packageTypeId['5g-tv'].includes(pck.id)) {
      fiveGWithTvPackages.push(pck);
    } else if (packageTypeId['5g-ready-tv'].includes(pck.id)) {
      fiveGReadyWithTVPackages.push(pck);
    } else if (packageTypeId['5g-ready-cabin'].includes(pck.id)) {
      fiveGReadyCabin.push(pck);
    } else if (packageTypeId['5g-cabin'].includes(pck.id)) {
      fiveGCabin.push(pck);
    }
  });

  const fourGWithOffer = fourGPackages.filter(pck => [10, 11, 12].indexOf(pck.id) !== -1);
  const fourGCabin = fourGPackages.filter(isCabin);
  const has4GOffer = fourGWithOffer.length > 0;
  const isCabinProduct = fourGCabin.length > 0;
  const hasCabinEstablishmentOffer =
    isCabinProduct && fourGCabin[0].offers.filter(offer => offer.id === cabinEstablishmentId).length > 0;

  const hasInstallamentOfferFiveG =
    fiveGPackages[0] &&
    (hasOfferOfId(fiveGPackages[0].offers, installmentOfferFiveG) ||
      hasOfferOfId(fiveGPackages[0].offers, fiveGreadyCabinCampaign));
  const hasFreeInstallamentFourG = fourGPackages[0] && hasOfferOfId(fourGPackages[0].offers, freeInstallmentFourG);
  const hasFreeInstallamentCabin = fourGCabin[0] && hasOfferOfId(fourGCabin[0].offers, freeInstallmentCabin);
  const hasFiveGCabinInstamentOffer =
    (fiveGReadyCabin[0] && hasOfferOfId(fiveGReadyCabin[0].offers, fiveGreadyCabinCampaign)) ||
    (fiveGCabin[0] && hasOfferOfId(fiveGCabin[0].offers, fiveGreadyCabinCampaign));

  return {
    has4GOffer,
    hasInstallamentOfferFiveG,
    hasFreeInstallamentFourG,
    hasFreeInstallamentCabin,
    isCabinProduct,
    hasCabinEstablishmentOffer,
    hasFiveGCabinInstamentOffer,
    fourGPackages: isCabinProduct ? fourGCabin : has4GOffer ? fourGWithOffer : fourGPackages,
    fiveGPackages,
    fiveGReadyPackages,
    fiveGWithTvPackages,
    fiveGReadyWithTVPackages,
    fiveGReadyCabin,
    fiveGCabin
  };
};
